module.exports = __webpack_public_path__ + "static/media/Barlow-ExtraLight.4ccc4f09.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Barlow-ExtraLight.ttf
// module id = 2847
// module chunks = 51